import { sentry } from './Sentry';

import { resolveEnv } from '@speeki/frontend-utils';
import { StorageManager } from '@speeki/storage-manager';

const BASE_GRAPH_API_URL_STRING = resolveEnv(
    'REACT_APP_GRAPHQL',
    'https://api.master.dev.speeki.cloud/graphql',
);

export class APIService {
    static _instance: APIService | null = null;

    private isInitialized = false;

    private current_global_graph_api: string = BASE_GRAPH_API_URL_STRING;
    private current_graph_api: string | undefined = undefined;

    constructor() {
        if (!APIService._instance) {
            APIService._instance = this;
        }
        return APIService._instance;
    }

    public async initialize() {
        if (!this.isInitialized) {
            await this.getGraphApiFromStorage();
            this.isInitialized = true;
        }
    }

    private async getGraphApiFromStorage() {
        const api = StorageManager.getValue('graphApi');
        this.setGraphAPI = api ?? undefined;
    }

    private static async persistGraphApi(api?: string) {
        if (api) StorageManager.setValue('graphApi', api);
    }

    public set setGraphAPI(api: string | undefined) {
        APIService.persistGraphApi(api)
            .then(() => {
                this.current_graph_api = api;
            })
            .catch((e) => {
                sentry.captureException(e);
                console.error('Cannot persist graph api::', e);
            });
    }

    public get getGraphAPI() {
        if (this.current_graph_api) return this.current_graph_api;
        else throw new GraphApiNotSelectedError('Graph API not selected');
    }

    public get getGlobalGraphAPI() {
        return this.current_global_graph_api;
    }
}

class GraphApiNotSelectedError extends Error {
    constructor(msg: string) {
        super(msg);
        this.name = 'GraphApiNotSelectedError';
        Object.setPrototypeOf(this, GraphApiNotSelectedError.prototype);
    }
}

export const getGraphApi = () => {
    try {
        const graphApi = new APIService().getGraphAPI;
        return graphApi;
    } catch {
        return null;
    }
};
